/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

export const UNPROCESSED_MODEL = 'This model has not been run';
